// https://docs.commercetools.com/http-api-projects-products#images
type CommerceToolsImageSuffix = "thumb" | "small" | "medium" | "large" | "zoom"

const getImageWithSizeSuffix = (
	urlWithoutFileExtension: string,
	fileExtension: string,
	suffix: CommerceToolsImageSuffix,
) => {
	return `${urlWithoutFileExtension}-${suffix}.${fileExtension}`
}

const getImageWithSizeSuffixes = (originalImageUrl: string) => {
	const [fileExtension, ...reversedUrlWithoutFileExtension] = originalImageUrl
		.split(".")
		.reverse()
	const urlWithoutFileExtension = reversedUrlWithoutFileExtension.reverse().join(".")

	const thumb = getImageWithSizeSuffix(urlWithoutFileExtension, fileExtension, "thumb")
	const small = getImageWithSizeSuffix(urlWithoutFileExtension, fileExtension, "small")
	const medium = getImageWithSizeSuffix(urlWithoutFileExtension, fileExtension, "medium")
	const large = getImageWithSizeSuffix(urlWithoutFileExtension, fileExtension, "large")
	const zoom = getImageWithSizeSuffix(urlWithoutFileExtension, fileExtension, "zoom")

	return {
		thumb,
		small,
		medium,
		large,
		zoom,
		original: originalImageUrl,
	}
}

export default getImageWithSizeSuffixes
